// Imperative confirm dialog driven by a single global state object.
//
// `confirm(options)` returns a Promise<boolean> resolved by the host
// component (`ConfirmDialogHost`) when the user clicks confirm or
// cancels (button, Escape, or backdrop). Use it instead of the native
// `window.confirm`, which is blocking, unstyled, and untranslatable.
//
//   const ok = await confirm({
//     title: t.delete_title,
//     message: t.delete_message,
//     confirmLabel: t.delete,
//     cancelLabel: t.cancel,
//     variant: "danger",
//   })
//   if (ok) router.delete(`/admin/users/${user.id}`)

import { reactive } from "vue"

const state = reactive({
  open: false,
  title: "",
  message: "",
  confirmLabel: "OK",
  cancelLabel: null,
  variant: "primary",
})

let pendingResolve = null

const settle = (value) => {
  const fn = pendingResolve
  pendingResolve = null
  state.open = false
  if (fn) fn(value)
}

export function confirm(options = {}) {
  if (pendingResolve) {
    settle(false)
  }

  state.title = options.title ?? ""
  state.message = options.message ?? ""
  state.confirmLabel = options.confirmLabel ?? "OK"
  state.cancelLabel = options.cancelLabel ?? null
  state.variant = options.variant ?? "primary"

  return new Promise((resolve) => {
    pendingResolve = resolve
    state.open = true
  })
}

export function useConfirmState() {
  return {
    state,
    resolve: settle,
  }
}
